var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0439 5.28125C14.1025 5.28126 14.1525 5.29723 14.2148 5.35938C14.2739 5.41847 14.2939 5.47112 14.2939 5.54102C14.2939 5.61084 14.2744 5.66235 14.2158 5.7207L14.2148 5.72168L7.33398 12.6211C7.2716 12.6835 7.22161 12.7001 7.16309 12.7002C7.10436 12.7002 7.05376 12.6836 6.99121 12.6211L3.7666 9.39648C3.71072 9.3406 3.69443 9.29437 3.69629 9.23047C3.69846 9.1566 3.72166 9.09867 3.78516 9.03516C3.84506 8.97525 3.89677 8.9559 3.96484 8.95605C4.01739 8.95618 4.06028 8.96746 4.10352 8.99805L4.14746 9.03516L6.80762 11.7148L7.16113 12.0713L7.5166 11.7158L13.8721 5.35938C13.9346 5.29685 13.9852 5.28125 14.0439 5.28125Z",
    stroke: "#1FB88D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseCheck);
export default __webpack_public_path__ + "static/media/license-check.b8b07f79202d5b912ceb0689bdf1f785.svg";
export { ForwardRef as ReactComponent };